export const SOLD_TEXT = "Bilen du var intresserad av har tyvärr hunnit bli såld till någon annan, men du kan lugnt surfa vidare efter liknande bilar som fortfarande är till salu.";
